import React, { useState, useEffect } from 'react';
import Picker from './Components/Picker';
import Game from './Game';
import BotController from './BotController';
import LocalController from './LocalController';
import OnlineController from './OnlineController';

const initialState = {init: false, gameid: null, name: '', socket: null, count: 3, type: "", status: 'setup', othername: 'Player 2'}

export default function Parent() {
	const [state, setState] = useState(initialState);
	const setup = () => {
		const localName = localStorage.getItem('username');
		const params = new URLSearchParams(window.location.search);
		const socket = params.get('socket') || null;
		const gameid = socket ? params.get('gameid') || null : null;
		setState(s => ({...s, name: localName || '', count: 3, init: true, inputName: localName?false:true, socket, type: socket?"online":"bot", gameid}));
	}
	useEffect(() => {
		setup();
	}, []);
	const start = (stateChanges={gameid: null}) => {
		localStorage.setItem('username', state.name);
		let controller;
		const newData = {...state, ...stateChanges};
		const params = new URLSearchParams(window.location.search);
		if(state.type==='local') {
			controller = new LocalController(newData);
			params.delete('socket')
		} else if(state.type==="bot") {
			controller = new BotController(newData);
		} else if(state.type==="online") {
			params.set('socket', newData.socket);
			controller = new OnlineController(newData);
		}
		params.delete('gameid')
		window.history.pushState({}, '', '?'+params.toString())
		setState(s => ({...s, ...stateChanges, status: 'playing', controller}))
	}
	const join = () => {
		start({gameid: parseInt(state.gameid)})
	}
	const reset = () => {
		setState(initialState)
		setup()
	}
	return !state.init?null:state.status==='setup'?(
		<div className="card form">
			{state.inputName?<label className="">
				<div className="">Your name</div>
				<input className="" onChange={e => setState(s => ({...s, name: e.target.value}))} value={state.name} type="text" />
			</label>:null}
			{state.type==="local"?<label className="">
				<div className="">Other player's name</div>
				<input className="" onChange={e => setState(s => ({...s, othername: e.target.value}))} value={state.othername || ''} type="text" />
			</label>:null}
			{state.type!=="online" || !state.socket || !state.gameid?<label className="">
				<div className="">Size of the game</div>
				<div className="row">
					<input className="" onChange={e => setState(s => ({...s, count: parseInt(e.target.value)}))} value={state.count+""} type="range" max="15" min="3" />
					<span className="">{state.count}x{state.count}</span>
				</div>
			</label>:null}
			<div className="row">
				<Picker
					options={[
						{value: 'online', label: 'Online Multiplayer', disabled: !state.socket?true:false},
						{value: 'bot', label: 'Bot'},
						{value: 'local', label: 'Local Multiplayer'},
					]}
					value={state.type}
					name="gametype"
					onChange={e => setState(s => ({...s, type: e.target.value}))}
				/>
			</div>
			{state.socket && state.type==="online"?<div className="row online-server-data">
				<div className="">Socket URL: {state.socket}</div>
				{state.gameid?<div className="">Game ID: {state.gameid}</div>:null}
			</div>:null}
			{state.type==="online" && state.socket && state.gameid?(
				<div className="row">
					<button className="sub" onClick={() => start()}>Create a New Game</button>
					<button className="main" onClick={join}>Join Game</button>
				</div>
			):(
				<button disabled={state.name.length<2 || state.count<3 || state.count>15 || isNaN(state.count)} onClick={start}>Start Game</button>
			)}
		</div>
	):state.status==='playing'?
		<Game controller={state.controller} socket={state.socket} count={state.count} name={state.name} gameid={state.gameid} othername={state.othername} reset={reset} />
	:null;
}
